import React, { Fragment } from 'react';
import {
  List,
  TextField,
  Datagrid,
  ReferenceManyField,
  SingleFieldList,
  ShowButton,
  Filter,
  CardActions,
  ExportButton,
  TextInput,
  SelectInput,
  DateField,
  SelectField, FunctionField,
} from 'react-admin';

import BulkAccountAproval from './BulkAccountApproval';
import { ADMIN_LEVELS, getAdminLevel } from '../../authProvider';
import { annualIncomeChoices, netWorthChoices } from '../../helpers/mappings';

const NewAccountsListActions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter,
}) => (
  <CardActions>
    {filters && React.cloneElement(filters, {
      resource,
      showFilter,
      displayedFilters,
      filterValues,
      context: 'button',
    }) }
    <ExportButton resource="newAccounts" />
  </CardActions>
);

const NewAccountsFilter = props => (
  <Filter {...props}>
    <TextInput label="Search" source="_OMNI_" alwaysOn />
    <TextInput label="First name" source="_LIKE_firstName" />
    <TextInput label="Last name" source="_LIKE_lastName" />
    <TextInput label="Email" source="_LIKE_email" />
    <SelectInput
      source="role"
      choices={[
        { id: '_null_', name: 'No Role' },
        { id: ADMIN_LEVELS.FULL_ADMIN, name: 'Full Admin' },
        { id: ADMIN_LEVELS.SUPERVISOR_ADMIN, name: 'Supervisor Admin' },
        { id: ADMIN_LEVELS.REGULAR_ADMIN, name: 'Regular Admin' },
        { id: ADMIN_LEVELS.READ_ONLY_ADMIN, name: 'Read Only Admin' },
      ]}
    />
  </Filter>
);

const NewAccountsBulkActions = props => (
  <Fragment>
    <BulkAccountAproval {...props} />
  </Fragment>
);

export default props => (
  <List
    {...props}
    title="New Accounts"
    sort={{ field: 'email', order: 'asc' }}
    filters={<NewAccountsFilter />}
    actions={<NewAccountsListActions />}
    bulkActionButtons={
      [ADMIN_LEVELS.FULL_ADMIN, ADMIN_LEVELS.SUPERVISOR_ADMIN].includes(getAdminLevel()) ?
        <NewAccountsBulkActions /> : false
    }
  >
    <Datagrid>
      <TextField source="email" />
      <TextField source="firstName" />
      <TextField source="lastName" />
      <DateField source="identity.dateOfBirth" label="Date Of Birth" />
      <ReferenceManyField label="Accounts" reference="accounts" target="userId">
        <SingleFieldList linkType={false}>
          <TextField source="accountNumber" />
        </SingleFieldList>
      </ReferenceManyField>
      <ReferenceManyField label="Restricted" reference="accounts" target="userId">
        <SingleFieldList linkType={false}>
          <FunctionField render={record => `${record.accountRestrictions.length > 0 ? 'Yes' : 'No'}`} />
        </SingleFieldList>
      </ReferenceManyField>
      <TextField source="employment.employmentStatus" label="Employment Status" />
      <SelectField source="finances.annualIncome" label="Annual Income" choices={annualIncomeChoices} />
      <SelectField source="finances.liquidNetWorth" label="Liquid Net Worth" choices={netWorthChoices} />
      <SelectField source="finances.totalNetWorth" label="Total Net Worth" choices={netWorthChoices} />
      <DateField source="createdAt" label="Created At" />
      <ShowButton basePath="users" />
    </Datagrid>
  </List>
);



// WEBPACK FOOTER //
// ./src/components/NewAccounts/List.js